import { useNavigate } from 'react-router-dom';

import { AppIcon } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, SxProps, Theme, Button, Typography } from '@mui/material';

const STRINGS = appStrings.modules.careerPath.summaryPage.strongFitPaths;

export function NoBlueprintStrongFitPaths() {
  const navigate = useNavigate();
  const onClick = () => {
    navigate(APP_ROUTE.SURVEY);
  };

  return (
    <Box sx={containerSx}>
      {/* Custom Blueprint Section */}
      <Box sx={blueprintSectionSx}>
        {/* Background Image Area */}
        <Box sx={blueprintImageAreaSx}>
          <Box
            sx={blueprintBackgroundSx}
            component="img"
            src="/images/blueprint-text-transparent-background.svg"
          />
        </Box>

        {/* Content Area */}
        <Box sx={blueprintContentAreaSx}>
          <Typography variant="display-xs-semibold" sx={blueprintTitleSx}>
            {STRINGS.forPersonalizedResults}
          </Typography>
          <Button
            id="career-path-take-blueprint-quiz-button"
            variant="contained"
            onClick={onClick}
            hierarchy="Primary"
            size="lg"
            fullWidth
            sx={buttonSx}
          >
            {STRINGS.takeBlueprintQuiz}
            <AppIcon diameter="24px" iconName="ArrowRight" color="Colors/Base/White" />
          </Button>
        </Box>
      </Box>

      {/* Block Image Section */}
      <Box sx={blockImageSx} component="img" src="/images/career-path-no-blueprint-block.svg" />
    </Box>
  );
}

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: backrs.radius['radius-xl'],
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  boxShadow: backrs.shadows['shadow-md'],
  transition: 'all 0.3s ease-in-out',
  width: '100%',
  overflow: 'hidden',
  '@container (min-width: 600px)': {
    flexDirection: 'row',
    height: '400px',
  },
  '@container (min-width: 900px)': {
    height: '500px',
  },
});

const blueprintSectionSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  borderBottom: `1px solid ${backrs.colors['Colors/Foreground/fg-secondary']}`,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  '@container (min-width: 600px)': {
    width: '400px',
    borderBottom: 'none',
    borderRight: `1px solid ${backrs.colors['Colors/Foreground/fg-secondary']}`,
  },
});

const blueprintImageAreaSx: SxProps<Theme> = ({ backrs }) => ({
  borderBottom: `1px solid ${backrs.colors['Colors/Foreground/fg-secondary']}`,
  flex: '1 1 40%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
  minHeight: '200px',
  backgroundColor: backrs.colors['Colors/Base/White'],
  backgroundImage: `linear-gradient(${backrs.colors['Brand/200']} 1px, transparent 1px),
                    linear-gradient(90deg, ${backrs.colors['Brand/200']} 1px, transparent 1px)`,
  backgroundSize: '20px 20px',
  '@container (min-width: 600px)': {
    minHeight: 'auto',
  },
});

const blueprintBackgroundSx: SxProps<Theme> = {
  maxWidth: '100%',
  maxHeight: '100%',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
  objectPosition: 'center',
  border: 'none',
};

const blueprintContentAreaSx: SxProps<Theme> = ({ backrs }) => ({
  flex: '1 1 0%',
  padding: backrs.spacing['spacing-2xl'],
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
});

const blueprintTitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
  marginBottom: backrs.spacing['spacing-xl'],
});

const buttonSx: SxProps<Theme> = ({ backrs }) => ({
  marginTop: backrs.spacing['spacing-xl'],
});

const blockImageSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  height: '300px',
  padding: `${backrs.spacing['spacing-xl']} ${0} ${backrs.spacing['spacing-xl']} ${backrs.spacing['spacing-xl']}`,
  paddingRight: 0,
  maxWidth: '100%',
  objectFit: 'cover',
  objectPosition: 'left',
  display: 'block',
  backgroundColor: backrs.colors['Colors/Base/White'],
  borderRadius: `0 0 ${backrs.radius['radius-xl']} ${backrs.radius['radius-xl']}`,
  flex: '1 1 auto',
  minWidth: 0,
  '@container (min-width: 600px)': {
    height: '100%',
    padding: `${backrs.spacing['spacing-7xl']} ${0} ${backrs.spacing['spacing-7xl']} ${backrs.spacing['spacing-xl']}`,
    borderRadius: `0 ${backrs.radius['radius-xl']} ${backrs.radius['radius-xl']} 0`,
  },
});
